export default {
    API_ENDPOINT: 'https://blooming-stream-59570.herokuapp.com/',
    TOKEN_KEY: 'sip-rate-client-auth-token',
}